// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { documentsStyles } from "@conklin/Overrides/Widgets/ProductDetails/ProductDetailsDocuments";
import IconFile from "@conklin/XDL/Icons/IconFile";
import IconLinkMinus from "@conklin/XDL/Icons/IconLinkMinus";
import IconLinkPlus from "@conklin/XDL/Icons/IconLinkPlus";
import { createLinkIconStyles } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

documentsStyles.wrapper = {
    css: css`
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    `,
};
documentsStyles.showMoreLink = createLinkIconStyles(IconLinkPlus, "small", "right");
documentsStyles.showLessLink = {
    ...createLinkIconStyles(IconLinkMinus, "small", "right", false, {
        icon: {
            iconProps: {
                css: css`
                    &,
                    svg {
                        width: 12px;
                    }
                `,
            },
        },
    }),
};

documentsStyles.documentLink = createLinkIconStyles(IconFile, "small");